import { render } from "./ChinaberryGamePage.vue?vue&type=template&id=9522099c&scoped=true"
import script from "./ChinaberryGamePage.vue?vue&type=script&lang=js"
export * from "./ChinaberryGamePage.vue?vue&type=script&lang=js"

import "./ChinaberryGamePage.vue?vue&type=style&index=0&id=9522099c&scoped=true&lang=css"
import "./ChinaberryGamePage.vue?vue&type=style&index=1&id=9522099c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9522099c"]])

export default __exports__